var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.reference_map[_vm.table_id]
    ? _c(
        "div",
        { staticClass: "switch", attrs: { id: "map-display-switch" } },
        [
          _c("span", { staticClass: "switch__text" }, [_vm._v("監控地圖")]),
          _vm._v(" "),
          _c("v-switch", {
            model: {
              value: _vm.is_monitor_open_emap,
              callback: function($$v) {
                _vm.is_monitor_open_emap = $$v
              },
              expression: "is_monitor_open_emap"
            }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }